'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'

import Modal from '@Modal/Modal'

import getFormStatus from '@/Form/Functions/getFormStatus'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'

let app = window.app;

export default class ValidateUserModal extends Component
{
	state =
	{
		open: false,
		data: { }
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__ValidateUserModal',
			cb: component.open
		});

		app.push(
		{
			event: 'deletedUser',
			cb: component.handleUserDeletion
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__ValidateUserModal',
			cb: component.open
		});

		app.delete(
		{
			event: 'deletedUser',
			cb: component.handleUserDeletion
		});
	}

	handleUserDeletion = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleClose(null, true);
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data
		});
	}

	validate = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/user/change-status',
		{
			id: state.data.id,
			new_state: state.data.validation_status === 'validated' ? 'disabled' : 'validated'
		})
		.then(function (xhr, response)
		{
			app.emit('validatedUser', component.state.data.id);

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	delete = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!state.data.id) return;

		app.emit('open__DeleteUserConfirmationModal', state.data);
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let text =
		(
			<p>Souhaitez-vous <strong>activer</strong> cet utilisateur&nbsp;?</p>
		);

		if (state.data.validation_status === 'validated')
		{
			text =
			(
				<p>Souhaitez-vous <strong>désactiver</strong> cet utilisateur&nbsp;?</p>
			);
		}

		let change_status, delete_user;

		if (['pending', 'disabled', 'validated'].includes(state.data.validation_status))
		{
			change_status =
			(
				<button className="c-btn c-dialog__danger u-margin-right-15"
					onClick={ component.validate }>
					{ state.data.validation_status === 'validated' ? 'Désactiver' : 'Activer' }
				</button>
			);
		}

		delete_user =
		(
			<button className="c-btn c-dialog__danger c-btn--red u-margin-right-15"
				onClick={ component.delete }>
				Supprimer
			</button>
		);

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Statut d'utilisateur" hide_close={ true }>

				{ text }

				<div className="u-center">

					<div className="name-in-modal">

						{ state.data['firstname'] + ' ' +
							state.data['lastname'] }
					</div>

				</div>

				<div className="c-dialog__buttons u-flex u-flex-wrap u-content-between">

					{ delete_user }

					<div>
						{ change_status }

						<button className="c-btn c-dialog__cancel"
							onClick={ component.handleClose }>
							Fermer
						</button>
					</div>

				</div>

				{ getFormStatus(state) }

				{ loader }

			</Modal>
		);

		return output;
	}
}
